import React from 'react';
import { CreditCardIcon } from 'lucide-react';
import { gluteProduct } from '../data/gluteCopy';
import { trackPixelEvent } from '../utils/metaPixel';
export type CtaTracking = {
  name: string;
  id: string;
  price: number;
  currency: string;
};
type CtaButtonProps = {
  label?: string;
  size?: 'md' | 'lg';
  className?: string;
  /** Checkout destination. Ignored when scrollToId is set. */
  href?: string;
  /** When set, the button scrolls to that element on the page instead of going to checkout. */
  scrollToId?: string;
  tone?: 'ember';
  tracking?: CtaTracking;
};
export function CtaButton({
  label = '¡QUIERO DESPERTAR MIS GLÚTEOS AHORA!',
  size = 'lg',
  className = '',
  href = gluteProduct.guideCheckoutUrl,
  scrollToId,
  tracking = {
    name: gluteProduct.name,
    id: gluteProduct.id,
    price: gluteProduct.guidePrice,
    currency: gluteProduct.currency
  }
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'w-full sm:w-auto px-5 py-3.5 text-[0.9rem] sm:px-8 sm:py-5 sm:text-base' : 'px-4 py-2.5 text-xs';
  const classes = `group inline-flex items-center justify-center gap-2 rounded-lg bg-ember text-center font-bold uppercase leading-tight tracking-wide text-coal-deep shadow-lift outline-none transition-[transform,background-color,box-shadow] duration-150 ease-smooth hover:bg-ember-light focus-visible:ring-4 focus-visible:ring-ember/40 active:translate-y-px ${sizing} ${className}`;
  const icon = <CreditCardIcon className={size === 'lg' ? 'h-4 w-4 shrink-0 sm:h-5 sm:w-5' : 'h-4 w-4 shrink-0'} aria-hidden="true" data-id="element-1" data-mp="3otxnc9dis7gk" />;
  if (scrollToId) {
    const handleScroll = (event: React.MouseEvent<HTMLAnchorElement>) => {
      const target = document.getElementById(scrollToId);
      if (!target) return;
      event.preventDefault();
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
        block: 'start'
      });
    };
    return <a href={`#${scrollToId}`} onClick={handleScroll} className={classes} data-id="element-2" data-mp="3mxqjvy2nmqgz">
        {icon}
        <span data-id="element-3" data-mp="3hzxdp51cpwgp">{label}</span>
      </a>;
  }
  const handleCheckout = () => {
    trackPixelEvent('AddToCart', {
      content_name: tracking.name,
      content_ids: tracking.id,
      content_type: 'product',
      value: tracking.price,
      currency: tracking.currency
    });
  };

  // Sin URL de checkout configurada: el botón registra el evento sin navegar a ningún sitio.
  if (!href) {
    return <button type="button" onClick={handleCheckout} className={classes} data-id="element-4" data-mp="4lkcsu82rh9e">
        {icon}
        <span data-id="element-5" data-mp="jfyyj2j0x4rr">{label}</span>
      </button>;
  }
  return <a href={href} target="_blank" rel="noopener noreferrer" onClick={handleCheckout} className={classes} data-id="element-6" data-mp="ehdyb33rul3b">
      {icon}
      <span data-id="element-7" data-mp="2l9y8nkketg2v">{label}</span>
    </a>;
}